import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'

export const state = {
  items: [],
  startLocation: null,
  endLocation: null,
  report: null,
  transferLogItems: []
}

export const getters = {
  items: state => state.items,
  startLocation: state => state.startLocation,
  endLocation: state => state.endLocation,
  report: state => state.report,
  transferLogItems: state => state.transferLogItems
}

export const mutations = {

  ITEMS (state, data) {
    state.items = data
  },

  START_LOCATION (state, data) {
    state.startLocation = data
  },

  END_LOCATION (state, data) {
    state.endLocation = data
  },

  REPORT (state, data) {
    state.report = data
  },

  TRANSFER_LOG_ITEMS (state, data) {
    state.transferLogItems = data
  }
}

export const actions = {
  async fetchItems ({ commit }) {
    await axios.get(laroute.route('cycle_count_items', { companyAbbr: store.getters['auth/company'] }))
      .then(res => {
        commit('ITEMS', res.data)
      })
  },

  async create ({ commit }, formData) {
    const { data } = await axios.post(laroute.route('add_cycle_count'), { companyAbbr: store.getters['auth/company'], formData: formData }, { responseType: 'arraybuffer' })
    commit('REPORT', data)
  },

  async update ({ commit }, cycleCount) {
    await axios.patch(laroute.route('update_cycle_count', { companyAbbr: store.getters['auth/company'], id: cycleCount.id }), { cycleCount: cycleCount })
  },

  async fetchStartAndEndLocations ({ commit }) {
    await axios.get(laroute.route('get_start_and_end_locations', { companyAbbr: store.getters['auth/company'] }))
      .then((res) => {
        commit('START_LOCATION', res.data.start)
        commit('END_LOCATION', res.data.end)
      })
  },

  async printEmptySessionList ({ commit }, cycleCountId) {
    const { data } = await axios.get(laroute.route('print-cycle-count-empty-session-list', { companyAbbr: store.getters['auth/company'], id: cycleCountId }), { responseType: 'arraybuffer' })
    commit('REPORT', data)
  },

  async printSessionList ({ commit }, cycleCountId) {
    const { data } = await axios.get(laroute.route('print-cycle-count-session-list', { companyAbbr: store.getters['auth/company'], id: cycleCountId }), { responseType: 'arraybuffer' })
    commit('REPORT', data)
  },

  async transferOneSession ({ dispatch, commit }, cycleCountId) {
    await axios.patch(laroute.route('cycle-count-transfer-session', { companyAbbr: store.getters['auth/company'], id: cycleCountId })).then(function () {
      dispatch('getTransferLogItems')
    })
  },

  async transfer ({ dispatch }) {
    await axios.patch(laroute.route('cycle-count-transfer', { companyAbbr: store.getters['auth/company'] })).then(() => {
      dispatch('getTransferLogItems')
    })
  },

  async clearTable () {
    await axios.delete(laroute.route('cycle_count_clear_table', { companyAbbr: store.getters['auth/company'] }))
  },

  async getTransferLogItems ({ commit }) {
    await axios.get(laroute.route('cycle_count_transfer_log', { companyAbbr: store.getters['auth/company'] }))
      .then((res) => {
        commit('TRANSFER_LOG_ITEMS', res.data)
      })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/cycleCount.js